import { Card } from '@acin/ui-core';
import styled from 'styled-components';

export const ProcessesList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  gap: ${(p) => p.theme.spacing.getSize(4)};
`;

export const Item = styled.div`
  padding: ${(p) => p.theme.spacing.getSize(3)};
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(p) => p.theme.colors.backgrounds.getValue(1)};
  }
`;

export const ItemName = styled.div`
  font-weight: 500;
  color: ${(p) => p.theme.colors.text.getValue(0)};
  margin-bottom: ${(p) => p.theme.spacing.getSize(1)};
`;

export const ItemDescription = styled.div`
  font-size: ${(p) => p.theme.type.getSize(-1)};
  color: ${(p) => p.theme.colors.text.getValue(1)};
  line-height: 1.4;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: ${(p) => p.theme.colors.text.getValue(2)};
  font-size: ${(p) => p.theme.type.getSize()};
  padding: ${(p) => p.theme.spacing.getSize(4)};
  text-align: center;
`;
